import { render, staticRenderFns } from "./AppSectionControl.vue?vue&type=template&id=539c0f72&"
import script from "./AppSectionControl.vue?vue&type=script&lang=js&"
export * from "./AppSectionControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports